import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Button, confirm, setOptions, toast as mbToast, Input, Popup} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Card, CardTitle, CardSubtitle, CardFooter, CardHeader, CardContent, Textarea, Listview, Button as MbButton} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardWorkspace.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faTrashCan,
    faCloudArrowDown,
    faFloppyDisk,
    faFilePen,
    faMagnifyingGlassChart,
    faWindowRestore,
    faMagnifyingGlass,
    faPencil,
    faMagnifyingGlassPlus,
    faSquareCheck,
    faSquareDashed,
    faLayerGroup,
    faLayerPlus,
    faCameraViewfinder,
    faUpload,
    faFontCase,
    faFileLines,
    faCode,
    faFileImage,
    faCirclePlay,
    faSquareFull,
    faNoteSticky,
    faArrowDownWideShort,
    faArrowUpShortWide,
    faEllipsisStrokeVertical,
    faPipe,
    faSquareDashedCirclePlus,
    faShareFromSquare
} from "@fortawesome/pro-duotone-svg-icons";
import Empty from "../utils/Empty";
import IconFile from "../utils/IconFile";
import Loading from "../utils/Loading";
import {NetworkContext} from "../utils/NetworkContext";
import Truncate from "../utils/Truncate";
import dayjs from "dayjs";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardWorkspace({locale, navigation, width, setToast, workspace, stack, setStack, toast, Dialog, setWorkspace, dialog, teamtalk, setWorkspaceItem, sort, setSort, setWorkspaceItemDialog, hiddenFileInput, InputScreen, setMyItem}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [info, setInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [iconHover, setIconHover] = useState(null);
    const [noteReload, setNoteReload] = useState(null);
    const [tab, setTab] = useState('workspace');
    const [results, setResults] = useState([]);
    const [items, setItems] = useState([]);
    const [text, setText] = useState(null);
    const [listInstance, setListInstance] = useState({});

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const Items = () => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'items',
            action: 'get',
            data: {}
        };
        wsCall(message);
    }

    const ItemIconOpen = data => {

        if (data.update) {
            return <FontAwesomeIcon className="cs-dashboard-workspace-icon-update" icon={faWindowRestore} />;
        } else if (data.type === 'graph') {
            return <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faMagnifyingGlassChart} />;
        } else if (data.type === 'calendar') {
            return <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faMagnifyingGlassPlus} />;
        } else if (data.type === 'text' || data.type === 'code') {
            return <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faPencil} />;
        } else if (data.type === 'file') {
            return <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faMagnifyingGlass} />;
        } else {
            return <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faFilePen} />;
        }
    }

    const ListItemStack = data => {
        data.item.height = '2';

        return <li data-id={data.item.id} onClick={() => listInstance.openActions(data.item.id, 'left')} >
            <div className="mbsc-row cs-dashboard-workspace-list" >
                <div className="mbsc-col-auto cs-dashboard-workspace-list-item" >
                    {!data.item.hover && IconFile(data.item)}
                </div>
                <div className="mbsc-col cs-dashboard-workspace-list-section">
                    <div className="mbsc-bold mbsc-txt-muted">{width < 768 ? Truncate(data.item.name, 30) : Truncate(data.item.name, 60)}</div>
                    <div className="mbsc-row mbsc-txt-s cs-dashboard-workspace-item-txt">
                        <span className="mbsc-txt-muted">{data.item.subtitle}</span>
                    </div>
                </div>
                <div className="mbsc-col-auto cs-dashboard-workspace-list-item" >
                    <FontAwesomeIcon className="cs-dashboard-workspace-list-menu" icon={faEllipsisStrokeVertical} />
                </div>
            </div>
        </li>;
    }

    const ListItemItem = data => {
        const itemDate = dayjs(parseInt(data.item.id)).format("YYYY-M-D");
        data.item.height = '2';

        return <li data-id={data.item.id} onClick={() => listInstance.openActions(data.item.id, 'left')} >
            <div className="mbsc-row cs-dashboard-workspace-list" >
                <div className="mbsc-col-auto cs-dashboard-workspace-list-item" >
                    {IconFile(data.item)}
                </div>
                <div className="mbsc-col cs-dashboard-workspace-list-section">
                    <div className="mbsc-bold mbsc-txt-muted">{width < 768 ? Truncate(data.item.name, 30) : Truncate(data.item.name, 60)}</div>
                    <div className="mbsc-row mbsc-txt-s cs-dashboard-workspace-item-txt">
                        <span className="mbsc-txt-muted">{data.item.subtitle}</span>
                        <FontAwesomeIcon className="cs-dashboard-workspace-pipe" icon={faPipe} />
                        <span className="mbsc-txt-muted">{itemDate}</span>
                    </div>
                </div>
                <div className="mbsc-col-auto cs-dashboard-workspace-list-item" >
                    <FontAwesomeIcon className="cs-dashboard-workspace-list-menu" icon={faEllipsisStrokeVertical} />
                </div>
            </div>
        </li>;
    }

    const ListItem = data => {
        if (tab === 'stack') {
            return ListItemStack(data);
        } else if (tab === 'items') {
            return ListItemItem(data);
        }
    }

    const ListData = () => {
        if (text) {
            return results;
        } else if (tab === 'items') {
            return items;
        } else if (tab === 'stack') {
            return stack;
        }
    }

    const ListActions = () => {
        if (tab === 'items') {
            return {
                right: [{
                    color: '#0B7DBB',
                    text: locale.dashboardWorkspace.a,
                    action: (event, inst) => {
                        setLoading(true);
                        const itemFile = text ? results[event.index].id : items[event.index].id;

                        const message = {
                            type: 'wss',
                            path: 'item-workspace',
                            action: 'put',
                            data: {
                                id: itemFile,
                                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                            }
                        };
                        wsCall(message);

                        return false;
                    }
                }, {
                    color: '#0B7DBB',
                    text: locale.dashboardWorkspace.aw,
                    action: (event, inst) => {
                        const myItem = text ? results[event.index] : items[event.index];
                        setMyItem(myItem);
                        Dialog({view: 'dashboardItemsRename'});

                        inst.close(event.target);

                        return false;
                    }
                }, {
                    color: '#0B7DBB',
                    text: locale.dashboardWorkspace.c,
                    action: (event, inst) => {
                        confirm({
                            title: locale.dashboardWorkspace.g,
                            message: locale.dashboardWorkspace.h,
                            okText: locale.dashboardWorkspace.c,
                            cancelText: locale.dashboardWorkspace.i,
                            callback: (res) => {
                                if (res) {
                                    setLoading(true);
                                    const itemFile = text ? results[event.index].id : items[event.index].id;

                                    const message = {
                                        type: 'wss',
                                        path: 'item',
                                        action: 'delete',
                                        data: {
                                            item: itemFile
                                        }
                                    };
                                    wsCall(message);
                                } else {
                                    inst.close(event.target);
                                }
                            }
                        });
                        return false;
                    }
                }]
            };
        } else if (tab === 'stack') {
            return {
                right: [{
                    color: '#0B7DBB',
                    text: locale.dashboardWorkspace.at,
                    action: (event, inst) => {
                        setLoading(true);
                        const itemStack = text ? results[event.index] : stack[event.index];

                        const message = {
                            type: 'wss',
                            path: 'workspace-item-unstack',
                            action: 'update',
                            data: {
                                id: itemStack.id,
                                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                            }
                        };
                        wsCall(message);

                        return false;
                    }
                }, {
                    color: '#0B7DBB',
                    text: locale.dashboardWorkspace.c,
                    action: (event, inst) => {

                        confirm({
                            title: locale.dashboardWorkspace.g,
                            message: locale.dashboardWorkspace.h,
                            okText: locale.dashboardWorkspace.c,
                            cancelText: locale.dashboardWorkspace.i,
                            callback: (res) => {
                                if (res) {
                                    setLoading(true);
                                    const itemStack = text ? results[event.index] : stack[event.index];

                                    const message = {
                                        type: 'wss',
                                        path: 'workspace-item',
                                        action: 'delete',
                                        data: {
                                            id: itemStack.id,
                                            teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                                            tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                                        }
                                    };
                                    wsCall(message);
                                }
                            }
                        });

                        return false;
                    }
                }, {
                    color: '#0B7DBB',
                    text: locale.dashboardWorkspace.l,
                    action: (event, inst) => {
                        const itemStack = text ? results[event.index] : stack[event.index];

                        if (itemStack.type === 'data' && !(itemStack.type === 'text' && itemStack.subtitle === 'note')) {
                            ButtonDataDownload(itemStack);
                        } else if (itemStack.type === 'app' && !(itemStack.type === 'text' && itemStack.subtitle === 'note')) {
                            ButtonRunSim(itemStack);
                        } else if (!(itemStack.type === 'file' || itemStack.type === 'data' || itemStack.type === 'action' || itemStack.type === 'patient' || itemStack.type === 'app' || (itemStack.type === 'text' && itemStack.subtitle === 'note'))) {
                            ButtonOpen(itemStack);
                        } else if (itemStack.type === 'file' && itemStack.subtitle.toLowerCase().includes('image') && !(itemStack.type === 'text' && itemStack.subtitle === 'note')) {
                            ButtonImage(itemStack);
                        } else if (itemStack.type === 'file' && !itemStack.subtitle.toLowerCase().includes('image') && !(itemStack.type === 'text' && itemStack.subtitle === 'note')) {
                            ButtonFileDownload(itemStack);
                        }

                        return false;
                    }
                }]
            };
        }
    }

    const NoteBackground = data => {
        if (data === 'yellow') {

            return "cs-dashboard-workspace-textarea cs-dashboard-workspace-textarea-yellow";
        } else if (data === 'green') {

            return "cs-dashboard-workspace-textarea cs-dashboard-workspace-textarea-green";
        } else if (data === "blue") {

            return "cs-dashboard-workspace-textarea cs-dashboard-workspace-textarea-blue";
        }
    }

    const ButtonInfo = () => {
        if (info) {
            setInfo(false);
        } else if (!info) {
            setInfo(true);
        }
    }

    const ButtonSelectToggle = data => {
        const array = workspace.map(item => {

            if (item.id === data && !item.selected) {
                item.selected = true;
            } else if (item.id === data && item.selected) {
                item.selected = false;
            }
            return item;
        });
        setWorkspace(array);
    }

    const ButtonStack = data => {
        setLoading(true);
        setToast({message: locale.dashboardWorkspace.ab, color: 'info', display: 'bottom'});

        const array = [];
        if (tab === 'select') {
            workspace.map(item => {
                if (item.selected) {
                    array.push(item.id);
                }
                return item;
            })
        }

        const message = {
            type: 'wss',
            path: 'workspace-item-stack',
            action: 'update',
            data: {
                id: tab === 'select' ? array : data.id,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        wsCall(message);
    }

    const ButtonRemove = data => {
        confirm({
            title: tab === 'select' ? locale.dashboardWorkspace.w : locale.dashboardWorkspace.g,
            message: tab === 'select' ? locale.dashboardWorkspace.x : locale.dashboardWorkspace.h,
            okText: locale.dashboardWorkspace.c,
            cancelText: locale.dashboardWorkspace.i,
            callback: (res) => {
                if (res) {
                    const array = [];
                    if (tab === 'select') {
                        workspace.map(item => {
                            if (item.selected) {
                                array.push(item.id);
                            }
                            return item;
                        })
                    }

                    const message = {
                        type: 'wss',
                        path: 'workspace-item',
                        action: 'delete',
                        data: {
                            id: tab === 'select' ? array : data.id,
                            teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                            tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                        }
                    };
                    wsCall(message);
                }
            }
        });
    }

    const ButtonRename = data => {
        setWorkspaceItemDialog(data);
        Dialog({view: 'dashboardWorkspaceRename'});
    }

    const ButtonFileDownload = data => {
        setLoading(true);
        setToast({message: locale.dashboardWorkspace.s, color: 'info', display: 'bottom'});

        const message = {
            type: 'wss',
            path: 'workspace-file',
            action: 'get',
            data: {
                id: data.id,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null
            }
        };
        wsCall(message);
    }

    const ButtonImage = data => {
        setLoading(true);
        setToast({message: locale.dashboardWorkspace.s, color: 'info', display: 'bottom'});

        const message = {
            type: 'wss',
            path: 'workspace-image',
            action: 'get',
            data: {
                id: data.id,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null
            }
        };
        wsCall(message);
    }

    const ButtonDataDownload = data => {
        setLoading(true);
        setToast({message: locale.dashboardWorkspace.s, color: 'info', display: 'bottom'});

        const message = {

            type: 'wss',
            path: 'workspace-data',
            action: 'get',
            data: {
                id: data.id,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null
            }
        };
        wsCall(message);
    }

    const ButtonOpen = data => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'workspace-item',
            action: 'get',
            data: {
                id: data.id,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        wsCall(message);
    }

    const ButtonRunSim = data => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'workspace-app',
            action: 'get',
            data: {
                id: data.id,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        wsCall(message);
    }

    const ButtonSave = data => {
        confirm({
            title: locale.dashboardWorkspace.an,
            message: locale.dashboardWorkspace.aq,
            okText: locale.dashboardWorkspace.k,
            cancelText: locale.dashboardWorkspace.i,
            callback: (res) => {
                if (res) {

                    const message = {
                        type: 'wss',
                        path: 'item',
                        action: 'put',
                        data: {
                            id: data.id,
                            teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null
                        }
                    };
                    wsCall(message);
                }
            }
        });
    }

    const ButtonCreate = data => {
        if (data === 'image') {
            Dialog({view: 'dashboardWorkspaceGenerate'});
        }  else if (data === 'screen') {
            InputScreen();
        } else if (data === 'upload') {
            hiddenFileInput.current.click();
        } else if (data === 'note') {

            const message = {
                type: 'wss',
                path: 'note',
                action: 'put',
                data: {
                    teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                    tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                }
            };
            wsCall(message);
        } else {
            setWorkspaceItemDialog({type: data});
            Dialog({view: 'dashboardWorkspaceAddName'});
        }
    }

    const ButtonNoteYellow = data => {
        setNoteReload(data.id);
        setWorkspace(prev => prev.map(item =>
            item.id === data.id ? {...item, color: 'yellow'} : item
        ));

        const message = {
            type: 'wss',
            path: 'note-color',
            action: 'update',
            data: {
                id: data.id,
                color: 'yellow',
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        wsCall(message);
    }

    const ButtonNoteGreen = data => {
        setNoteReload(data.id);
        setWorkspace(prev => prev.map(item =>
            item.id === data.id ? {...item, color: 'green'} : item
        ));

        const message = {
            type: 'wss',
            path: 'note-color',
            action: 'update',
            data: {
                id: data.id,
                color: 'green',
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        wsCall(message);
    }

    const ButtonNoteBlue = data => {
        setNoteReload(data.id);
        setWorkspace(prev => prev.map(item =>
            item.id === data.id ? {...item, color: 'blue'} : item
        ));

        const message = {
            type: 'wss',
            path: 'note-color',
            action: 'update',
            data: {
                id: data.id,
                color: 'blue',
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        wsCall(message);
    }

    const ButtonMenu = data => {
        if (tab === 'select') {
            if (workspace.some(item => item.selected)) {
                const array = workspace.map(item => {
                    const {selected, ...rest} = item;
                    return rest;
                })
                setWorkspace(array);
            }
        } else if (data === 'items') {
            Items();
        } else if (data === 'stack' && stack.length !== 0) {
            setStack(prev => [...prev].sort((a, b) => sort ? Number(b.id) - Number(a.id) : Number(a.id) - Number(b.id)))
        } else if (data === 'workspace' && workspace.length !== 0) {
            setWorkspace(prev => [...prev].sort((a, b) => sort ? Number(b.id) - Number(a.id) : Number(a.id) - Number(b.id)))
        }
        setTab(data);
    }

    const ButtonSort = () => {
        if (results.length !== 0) {

            setResults(prev => [...prev].sort((a, b) => sort ? Number(a.id) - Number(b.id) : Number(b.id) - Number(a.id)));
        }
        if (results.length === 0 && tab === 'workspace' && workspace.length !== 0) {

            setWorkspace(prev => [...prev].sort((a, b) => sort ? Number(a.id) - Number(b.id) : Number(b.id) - Number(a.id)));
        }
        if (results.length === 0 && tab === 'stack' && stack.length !== 0) {
            setStack(prev => [...prev].sort((a, b) => sort ? Number(a.id) - Number(b.id) : Number(b.id) - Number(a.id)));
        }
        if (results.length === 0 && tab === 'items' && items.length !== 0) {

            setItems(prev => [...prev].sort((a, b) => sort ? Number(a.id) - Number(b.id) : Number(b.id) - Number(a.id)));
        }

        if (sort) {
            setSort(false);
        } else {
            setSort(true);
        }
    }

    const InputPaste = data => {
        data.preventDefault();
        const items = data.clipboardData.items;
        setToast({message: locale.dashboardWorkspace.m, color: 'info', display: 'bottom'});

        for (const item of items) {
            const itemFile = item.getAsFile();

            const reader = new FileReader();
            reader.onloadend = () => {

                const workspaceItem = reader.result;
                const itemName = itemFile.name;
                const itemType = itemFile.type;

                const message = {
                    type: 'wss',
                    path: 'workspace-file',
                    action: 'put',
                    data: {
                        file: workspaceItem,
                        name: itemName,
                        type: itemType,
                        teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                        tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                    }
                };
                wsCall(message);
            };
            reader.readAsDataURL(itemFile);
        }
    }

    const InputDrop = data => {
        data.preventDefault();
        const items = data.dataTransfer.items;
        setToast({message: locale.dashboardWorkspace.m, color: 'info', display: 'bottom'});

        for (const item of items) {
            const itemFile = item.getAsFile();

            const reader = new FileReader();
            reader.onloadend = () => {

                const workspaceItem = reader.result;
                const itemName = itemFile.name;
                const itemType = itemFile.type;

                const message = {
                    type: 'wss',
                    path: 'workspace-file',
                    action: 'put',
                    data: {
                        file: workspaceItem,
                        name: itemName,
                        type: itemType,
                        teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                        tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                    }
                };
                wsCall(message);
            };
            reader.readAsDataURL(itemFile);
        }
    }

    const InputUpload = data => {
        const itemFile = data.target.files[0];
        setToast({message: locale.dashboardWorkspace.m, color: 'info', display: 'bottom'});

        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const itemData = reader.result;
            const itemName = itemFile.name;
            const itemType = itemFile.type;

            const message = {
                type: 'wss',
                path: 'workspace-file',
                action: 'put',
                data: {
                    file: itemData,
                    name: itemName,
                    type: itemType,
                    teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                    tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                }
            };
            wsCall(message);
        })
        reader.readAsDataURL(itemFile);
    }

    const InputNote = (id, value) => {
        setWorkspace(prev => prev.map(item =>
            item.id === id ? {...item, note: value} : item
        ));

        const message = {
            type: 'wss',
            path: 'note',
            action: 'update',
            data: {
                id: id,
                note: value,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        wsCall(message);
    };

    const InputSuggestion = data => {
        setText(data);
        const query = data.trim().toLowerCase();

        if (!query) {
            setResults([]);
            return;
        }
        if (tab === 'workspace') {
            const filtered = workspace.filter(item =>
                item.name.toLowerCase().includes(query)
            );
            setResults(filtered);
        } else if (tab === 'stack') {
            const filtered = stack.filter(item =>
                item.name.toLowerCase().includes(query)
            );
            setResults(filtered);
        } else if (tab === 'items') {
            const filtered = items.filter(item =>
                item.name.toLowerCase().includes(query)
            );
            setResults(filtered);
        }
    };

    const PutItem = useCallback(data => {
        if (data.toast){
            mbToast({message: locale.dashboardWorkspace.o, color: 'info', display: 'bottom', duration: 1000});
        }
        if (data.error){
            mbToast({message: locale.dashboardWorkspace.p, color: 'danger', display: 'bottom', duration: 3000});
        }
    }, [locale.dashboardWorkspace.o, locale.dashboardWorkspace.p]);

    const GetWorkspaceItem = useCallback(data => {
        if (data.item) {
            setWorkspaceItem(data.item);
            if (data.item.type === 'calendar') {
               Dialog({view: 'dashboardWorkspaceEvent'});
            } else {
                DialogClose();
            }
        }
        setLoading(false);
    }, [Dialog, DialogClose]);

    const GetWorkspaceApp = useCallback(data => {
        if (data.item) {
            setWorkspaceItem(data.item);
        }
        setLoading(false);
        DialogClose();
    }, [DialogClose]);

    const GetWorkspaceData = useCallback(data => {
        if (data.item && data.name && data.type) {
            if (data.type === 'csv') {

                const csvContent = data.item;

                const downloadLink = document.createElement('a');
                downloadLink.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
                downloadLink.download = data.name;
                downloadLink.style.display = 'none';

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            } else if (data.type === 'json') {

                const jsonString = JSON.stringify(data.item, null, 2);

                const downloadLink = document.createElement('a');
                downloadLink.href = 'data:application/json;charset=utf-8,' + encodeURIComponent(jsonString);
                downloadLink.download = data.name;
                downloadLink.style.display = 'none';

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
        }
        DialogClose();
    }, [DialogClose]);

    const UpdateWorkspaceItemStack = useCallback(data => {
        if (data.workspace) {
            const workspaceItems = data.workspace.filter(item => !item.stacked || item.stacked === false).sort((a, b) => sort ? (Number(b.id) - Number(a.id)) : (Number(a.id) - Number(b.id)));
            const array = data.workspace.filter(item => item.stacked === true);
            const stackItems = array.map((item, index) => ({...item, stackClass: index}));

            setWorkspace(workspaceItems);
            setStack(stackItems);
        }
        if (data.toast){
            mbToast({message: locale.dashboardWorkspace.f, color: 'info', display: 'bottom', duration: 1000});
        }
        setLoading(false);
    }, [locale.dashboardWorkspace.f, sort]);

    const UpdateWorkspaceItemUnstack = useCallback(data => {
        let stackItems = [];
        if (data.workspace) {
            const workspaceItems = data.workspace.filter(item => !item.stacked || item.stacked === false).sort((a, b) => sort ? (Number(b.id) - Number(a.id)) : (Number(a.id) - Number(b.id)));
            const array = data.workspace.filter(item => item.stacked === true);
            stackItems = array.map((item, index) => ({...item, stackClass: index}));

            setWorkspace(workspaceItems);
            setStack(stackItems);
        }
        mbToast({message: locale.dashboardWorkspace.au, color: 'info', display: 'bottom', duration: 1000});
        if (stackItems.length === 0 && tab === 'stack') {
            setTab('workspace');
        }
        setLoading(false);
    }, [sort, locale.dashboardWorkspace.au, tab]);

    const GetWorkspaceImage = useCallback(data => {
        if (data.item) {
            setWorkspaceItem(data.item);
        }
        DialogClose();
    }, [DialogClose]);

    const PutNote = useCallback(data => {
        if (data.workspace) {
            const workspaceItems = data.workspace.filter(item => !item.stacked || item.stacked === false).sort((a, b) => sort ? (Number(b.id) - Number(a.id)) : (Number(a.id) - Number(b.id)));
            const array = data.workspace.filter(item => item.stacked === true);
            const stackItems = array.map((item, index) => ({...item, stackClass: index}));

            setWorkspace(workspaceItems);
            setStack(stackItems);
        }
        if (data.error){
            mbToast({message: locale.dashboardWorkspace.n, color: 'danger', display: 'bottom', duration: 3000});
        } else {
            mbToast({message: locale.dashboardWorkspace.f, color: 'info', display: 'bottom', duration: 1000});
        }
    }, [locale.dashboardWorkspace.f, locale.dashboardWorkspace.n, sort]);

    const UpdateNote = useCallback(data => {
        if (data.toast) {

        }
    }, []);

    const UpdateNoteColor = useCallback(data => {
        if (data.toast){
            mbToast({message: locale.dashboardWorkspace.f, color: 'info', display: 'bottom', duration: 1000});
        }
        setNoteReload(null);
    }, [locale.dashboardWorkspace.f]);

    const DeleteWorkspaceItem = useCallback(data => {
        let stackItems = [];
        if (data.workspace) {
            const workspaceItems = data.workspace.filter(item => !item.stacked || item.stacked === false).sort((a, b) => sort ? (Number(b.id) - Number(a.id)) : (Number(a.id) - Number(b.id)));
            const array = data.workspace.filter(item => item.stacked === true);
            stackItems = array.map((item, index) => ({...item, stackClass: index}));

            setWorkspace(workspaceItems);
            setStack(stackItems);
        }
        mbToast({message: locale.dashboardWorkspace.av, color: 'info', display: 'bottom', duration: 1000});
        if (!(tab === 'stack' && stackItems.length !== 0)) {
            setTab( 'workspace');
        }
        setLoading(false);
    }, [locale.dashboardWorkspace.av, sort, tab]);

    const UpdateWorkspaceItemCalendar = useCallback(data => {
        if (data.workspace) {
            const workspaceItems = data.workspace.filter(item => !item.stacked || item.stacked === false).sort((a, b) => sort ? (Number(b.id) - Number(a.id)) : (Number(a.id) - Number(b.id)));
            const array = data.workspace.filter(item => item.stacked === true);
            const stackItems = array.map((item, index) => ({...item, stackClass: index}));

            setWorkspace(workspaceItems);
            setStack(stackItems);
        }
        if (data.toast) {
            setToast({message: locale.dashboardWorkspace.f, color: 'info', display: 'bottom', duration: 1000});
        }
        Dialog({view: 'close'});
        setWorkspaceItem({});
        setLoading(false);
    }, [Dialog, locale.dashboardWorkspace.f, sort]);

    const GetItems = useCallback(data => {
        if (data.items) {
            setItems(data.items.sort((a, b) => sort ? (Number(b.id) - Number(a.id)) : (Number(a.id) - Number(b.id))));
        } else {
            setItems([]);
        }
        setLoading(false);
    }, [sort]);

    const PutItemWorkspace = useCallback(data => {
        if (data.workspace) {
            const workspaceItems = data.workspace.filter(item => !item.stacked || item.stacked === false).sort((a, b) => sort ? (Number(b.id) - Number(a.id)) : (Number(a.id) - Number(b.id)));
            const array = data.workspace.filter(item => item.stacked === true);
            const stackItems = array.map((item, index) => ({...item, stackClass: index}));

            setWorkspace(workspaceItems);
            setStack(stackItems);
        }
        if (data.toast) {
            mbToast({message: locale.dashboardWorkspace.au, color: 'info', display: 'bottom', duration: 1000});
        }
        setLoading(false);
    }, [locale.dashboardWorkspace.au, sort, toast]);

    const DeleteItem = useCallback(data => {
        if (data.items) {
            setItems(data.items.sort((a, b) => sort ? (Number(b.id) - Number(a.id)) : (Number(a.id) - Number(b.id))));
        } else {
            setItems([]);
        }
        setLoading(false);
    }, [sort]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'delete' && wsResponse.path === 'item') {
            DeleteItem(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteItem, setWsResponse]);

    useEffect(() => {
        if (!Empty(wsResponse) && wsResponse.action === 'put' && wsResponse.path === 'item-workspace') {
            PutItemWorkspace(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, PutItemWorkspace, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'items') {
            GetItems(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetItems, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'workspace-item-calendar') {
            UpdateWorkspaceItemCalendar(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateWorkspaceItemCalendar, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'delete' && wsResponse.path === 'workspace-item') {
            DeleteWorkspaceItem(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteWorkspaceItem, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'put' && wsResponse.path === 'note') {
            PutNote(wsResponse.data);
            setWsResponse({});
            setToast({});
        }
    }, [wsResponse, PutNote, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'note') {
            UpdateNote(wsResponse.data);
            setWsResponse({});
            setToast({});
        }
    }, [wsResponse, UpdateNote, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'note-color') {
            UpdateNoteColor(wsResponse.data);
            setWsResponse({});
            setToast({});
        }
    }, [wsResponse, UpdateNoteColor, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'workspace-image') {
            GetWorkspaceImage(wsResponse.data);
            setWsResponse({});
            setToast({});
        }
    }, [wsResponse, GetWorkspaceImage, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'workspace-item') {
            GetWorkspaceItem(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetWorkspaceItem, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'workspace-app') {
            GetWorkspaceApp(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetWorkspaceApp, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'workspace-data') {
            GetWorkspaceData(wsResponse.data);
            setWsResponse({});
            setToast({});
        }
    }, [wsResponse, GetWorkspaceData, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'workspace-item-stack') {
            UpdateWorkspaceItemStack(wsResponse.data);
            setWsResponse({});
            setToast({});
        }
    }, [wsResponse, UpdateWorkspaceItemStack, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'workspace-item-unstack') {
            UpdateWorkspaceItemUnstack(wsResponse.data);
            setWsResponse({});
            setToast({});
        }
    }, [wsResponse, UpdateWorkspaceItemUnstack, setWsResponse]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'put' && wsResponse.path === 'item') {
            PutItem(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, PutItem, setWsResponse]);

    useEffect(() => {
        if (text) {
            setText(null);
            setResults([]);
        }
    }, [loading]);

    useEffect(() => {
        if (dialog.tab === 'items') {
            Items();
        }
        setTab(dialog.tab ? dialog.tab : 'workspace');
    }, []);

    return (
        <Popup className="cs-dashboard-workspace-popup" display="bottom" fullScreen={true} scrollLock={false} maxHeight={width > 768 ? 700 : 600} buttons={(stack && stack.length !== 0) ? [{text: locale.dashboardWorkspace.e, cssClass: tab === 'new' ? 'cs-dashboard-workspace-color-selected' : 'cs-dashboard-workspace-color', handler: function (event) {tab !== 'new' && ButtonMenu('new')}}, {text: locale.dashboardWorkspace.b, cssClass: tab === 'items' ? 'cs-dashboard-workspace-color-selected' : 'cs-dashboard-workspace-color', handler: function (event) {tab !== 'items' && ButtonMenu('items');}}, {text: locale.dashboardWorkspace.z, cssClass: tab === 'stack' ? 'cs-dashboard-workspace-color-selected' : 'cs-dashboard-workspace-color', handler: function (event) {tab !== 'stack' && ButtonMenu('stack');}}, {text: locale.dashboardWorkspace.a, cssClass: tab === 'workspace' ? 'cs-dashboard-workspace-color-selected' : 'cs-dashboard-workspace-color', handler: function (event) {tab !== 'workspace' && ButtonMenu('workspace');}}] : [{text: locale.dashboardWorkspace.e, cssClass: tab === 'new' ? 'cs-dashboard-workspace-color-selected' : 'cs-dashboard-workspace-color', handler: function (event) {tab !== 'new' && ButtonMenu('new')}}, {text: locale.dashboardWorkspace.b, cssClass: tab === 'items' ? 'cs-dashboard-workspace-color-selected' : 'cs-dashboard-workspace-color', handler: function (event) {tab !== 'items' && ButtonMenu('items');}}, {text: locale.dashboardWorkspace.a, cssClass: tab === 'workspace' ? 'cs-dashboard-workspace-color-selected' : 'cs-dashboard-workspace-color', handler: function (event) {tab !== 'workspace' && ButtonMenu('workspace');}}]} isOpen={dialog.view === 'dashboardWorkspace'} onClose={DialogClose}>
            {loading &&
                <div className="mbsc-row mbsc-justify-content-center cs-dashboard-workspace-main" >
                    <Loading />
                </div>
            }
            {!loading && (tab === 'stack' || (tab === 'items' && items && items.length !== 0) || ((tab === 'workspace' || tab === 'select') && ((workspace && workspace.length !== 0) || (results && results.length !== 0)))) &&
                <div className="mbsc-grid cs-dashboard-workspace-col cs-dashboard-workspace-header-secondary" >
                    <div className={tab === 'select' ? "mbsc-row cs-dashboard-workspace-main-buttons" : "mbsc-row cs-dashboard-workspace-main"}>
                        <div className="mbsc-col cs-dashboard-workspace-col" >
                            {(tab === 'workspace' || tab === 'stack' || tab === 'items') &&
                                <Input
                                    inputStyle="underline"
                                    placeholder={locale.dashboardWorkspace.ac}
                                    className="cs-dashboard-workspace-input-search"
                                    labelStyle="floating"
                                    type="text"
                                    name="search"
                                    value={text}
                                    onChange={ev => InputSuggestion(ev.target.value)}
                                />
                            }
                        </div>
                        {(tab === 'workspace' || tab === 'stack' || tab === 'items') &&
                            <div className="mbsc-col-auto cs-dashboard-workspace-col-sort" >
                                <Button title={locale.dashboardWorkspace.y} onMouseEnter={() => setIconHover('sort')} onMouseLeave={() => setIconHover(null)} disabled={Boolean(!Empty(toast))} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonSort()} >
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={sort ? faArrowUpShortWide : faArrowDownWideShort} beatFade={iconHover === 'sort'} />
                                </Button>
                                {tab === 'workspace' &&
                                    <Button title={locale.dashboardWorkspace.v} onMouseEnter={() => setIconHover('select')} onMouseLeave={() => setIconHover(null)} disabled={Boolean(!Empty(toast))} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonMenu('select')} >
                                        <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faSquareDashedCirclePlus} beatFade={iconHover === 'select'} />
                                    </Button>
                                }
                            </div>
                        }
                        {tab === 'select' &&
                            <div className="mbsc-col-auto cs-dashboard-workspace-col-buttons" >
                                <Button onMouseEnter={() => setIconHover('stackSelect')} onMouseLeave={() => setIconHover(null)} disabled={Boolean(!Empty(toast)) || !workspace.some(item => item.selected)} color="primary" variant="flat" className="cs-dashboard-workspace-color" onClick={() => ButtonStack()} >
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faLayerGroup} beatFade={iconHover === 'stackSelect'} /><div className="cs-dashboard-workspace-menu-text">{locale.dashboardWorkspace.z}</div>
                                </Button>
                                <Button onMouseEnter={() => setIconHover('trash')} onMouseLeave={() => setIconHover(null)} disabled={Boolean(!Empty(toast)) || !workspace.some(item => item.selected)} color="primary" variant="flat" className="cs-dashboard-workspace-color" onClick={() => ButtonRemove()} >
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faTrashCan} beatFade={iconHover === 'trash'} /><div className="cs-dashboard-workspace-menu-text">{locale.dashboardWorkspace.c}</div>
                                </Button>
                                <Button title={locale.dashboardWorkspace.v} onMouseEnter={() => setIconHover('unselect')} onMouseLeave={() => setIconHover(null)} disabled={Boolean(!Empty(toast))} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonMenu('workspace')} >
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faShareFromSquare} beatFade={iconHover === 'unselect'} />
                                </Button>
                            </div>
                        }
                    </div>
                </div>
            }
            {!loading && (tab === 'workspace' || tab === 'select') && (!workspace || workspace.length === 0) &&
                <div className="mbsc-grid cs-dashboard-workspace-grid" contentEditable suppressContentEditableWarning={true} onPaste={InputPaste} onDragOver={(e) => e.preventDefault()} onDrop={InputDrop}>
                    <div className="mbsc-row cs-dashboard-workspace-main mbsc-justify-content-center">
                        <div className="mbsc-col-12 cs-dashboard-workspace-col">
                            <Card theme="ios" themeVariant="light" contentEditable="false" className="cs-dashboard-workspace-card-empty" >
                                <CardHeader theme="ios" themeVariant="light" className="mbsc-align-center">
                                    {IconFile({type: 'empty', height: '3'})}
                                    <CardTitle theme="ios" themeVariant="light" className="cs-dashboard-workspace-title-empty" >
                                        {locale.dashboardWorkspace.d}
                                    </CardTitle>
                                    <CardSubtitle>
                                        {locale.dashboardWorkspace.ah}
                                    </CardSubtitle>
                                    <CardSubtitle>
                                        {locale.dashboardWorkspace.ap}
                                    </CardSubtitle>
                                </CardHeader>
                            </Card>
                        </div>
                    </div>
                </div>
            }
            {!loading && (tab === 'workspace' || tab === 'select') && ((workspace && workspace.length !== 0) || (results && results.length !== 0)) &&
                <div className="mbsc-grid cs-dashboard-workspace-grid cs-dashboard-workspace-scroll" contentEditable suppressContentEditableWarning={true} onPaste={InputPaste} onDragOver={(e) => e.preventDefault()} onDrop={InputDrop}>
                    <div className="mbsc-row cs-dashboard-workspace-main">
                        {!text && workspace && workspace.length !== 0 &&workspace.map(item => {
                            item.height = '2.45';

                            return (
                                <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-6 mbsc-col-lg-6 mbsc-col-xl-6 cs-dashboard-workspace-col"}>
                                    <Card theme="ios" themeVariant="light" contentEditable="false">
                                        {(item.type === 'text' && item.subtitle === 'note') && (!noteReload || (noteReload && noteReload !== item.id)) &&
                                            <CardContent theme="ios" themeVariant="light" className={NoteBackground(item.color)} >
                                                <Textarea
                                                    theme="ios"
                                                    themeVariant="light"
                                                    inputStyle="underline"
                                                    value={item.note}
                                                    onChange={(ev) => InputNote(item.id, ev.target.value)}
                                                />
                                            </CardContent>
                                        }
                                        {!(item.type === 'text' && item.subtitle === 'note') &&
                                            <CardHeader theme="ios" themeVariant="light" className="cs-dashboard-workspace-card-title">
                                                <div className="mbsc-avatar cs-dashboard-workspace-avatar">
                                                    {IconFile(item)}
                                                </div>
                                                <CardTitle theme="ios" themeVariant="light" className="mbsc-align-right cs-dashboard-workspace-cursor cs-dashboard-workspace-title" onDoubleClick={() => tab !== 'select' && ButtonRename(item)} >
                                                    {item.name}
                                                </CardTitle>
                                                <CardSubtitle theme="ios" themeVariant="light" className="mbsc-align-right" >
                                                    {item.subtitle}
                                                </CardSubtitle>
                                            </CardHeader>
                                        }
                                        <CardFooter theme="ios" themeVariant="light" className="cs-dashboard-workspace-footer" >
                                            <div className="mbsc-row" >
                                                <div className="mbsc-col-auto cs-dashboard-workspace-footer-left">
                                                    {tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.z} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonStack(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faLayerPlus} />
                                                        </MbButton>
                                                    }
                                                    {!(item.type === 'calendar' || item.type === 'action' || item.type === 'patient' || (item.type === 'text' && item.subtitle === 'note')) && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.k} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonSave(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faFloppyDisk} />
                                                        </MbButton>
                                                    }
                                                    {item.type !== 'calendar' && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.c} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonRemove(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faTrashCan} />
                                                        </MbButton>
                                                    }
                                                </div>
                                                <div className="mbsc-col cs-dashboard-workspace-footer-right">
                                                    {tab === 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast)) || item.type === 'calendar'} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonSelectToggle(item.id)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={item.selected ? faSquareCheck : faSquareDashed} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'data' && tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.j} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonDataDownload(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faCloudArrowDown} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'app' && tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.t} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonRunSim(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faCirclePlay} />
                                                        </MbButton>
                                                    }
                                                    {!(item.type === 'file' || item.type === 'data' || item.type === 'action' || item.type === 'patient' || item.type === 'app' || (item.type === 'text' && item.subtitle === 'note')) && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.l} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonOpen(item)} >
                                                            {ItemIconOpen(item)}
                                                        </MbButton>
                                                    }
                                                    {item.type === 'file' && item.subtitle.toLowerCase().includes('image') && tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.l} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonImage(item)} >
                                                            {ItemIconOpen(item)}
                                                        </MbButton>
                                                    }
                                                    {item.type === 'file' && !item.subtitle.toLowerCase().includes('image') && tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.j} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonFileDownload(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faCloudArrowDown} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'text' && item.subtitle === 'note' && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast)) || item.color === 'yellow'} title={locale.dashboardWorkspace.q} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color-yellow" onClick={() => ButtonNoteYellow(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faSquareFull} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'text' && item.subtitle === 'note' && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast)) || item.color === 'green'} title={locale.dashboardWorkspace.r} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color-green" onClick={() => ButtonNoteGreen(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faSquareFull} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'text' && item.subtitle === 'note' && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast)) || item.color === 'blue'} title={locale.dashboardWorkspace.ar} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color-blue" onClick={() => ButtonNoteBlue(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faSquareFull} />
                                                        </MbButton>
                                                    }
                                                </div>
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </div>
                            );
                        })}
                        {text && results && results.length !== 0 &&results.map(item => {
                            item.height = '2.45';

                            return (
                                <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-6 mbsc-col-lg-6 mbsc-col-xl-6 cs-dashboard-workspace-col"}>
                                    <Card theme="ios" themeVariant="light" contentEditable="false">
                                        {(item.type === 'text' && item.subtitle === 'note') && (!noteReload || (noteReload && noteReload !== item.id)) &&
                                            <CardContent theme="ios" themeVariant="light" className={NoteBackground(item.color)} >
                                                <Textarea
                                                    theme="ios"
                                                    themeVariant="light"
                                                    inputStyle="underline"
                                                    value={item.note}
                                                    onChange={(ev) => InputNote(item.id, ev.target.value)}
                                                />
                                            </CardContent>
                                        }
                                        {!(item.type === 'text' && item.subtitle === 'note') &&
                                            <CardHeader theme="ios" themeVariant="light" className="cs-dashboard-workspace-card-title">
                                                <div className="mbsc-avatar cs-dashboard-workspace-avatar">
                                                    {IconFile(item)}
                                                </div>
                                                <CardTitle theme="ios" themeVariant="light" className="mbsc-align-right cs-dashboard-workspace-cursor cs-dashboard-workspace-title" onDoubleClick={() => tab !== 'select' && ButtonRename(item)} >
                                                    {item.name}
                                                </CardTitle>
                                                <CardSubtitle theme="ios" themeVariant="light" className="mbsc-align-right" >
                                                    {item.subtitle}
                                                </CardSubtitle>
                                            </CardHeader>
                                        }
                                        <CardFooter theme="ios" themeVariant="light" className="cs-dashboard-workspace-footer" >
                                            <div className="mbsc-row" >
                                                <div className="mbsc-col-auto cs-dashboard-workspace-footer-left">
                                                    {tab === 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast)) || item.type === 'calendar'} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonSelectToggle(item.id)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={item.selected ? faSquareCheck : faSquareDashed} />
                                                        </MbButton>
                                                    }
                                                    {tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.z} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonStack(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faLayerPlus} />
                                                        </MbButton>
                                                    }
                                                </div>
                                                <div className="mbsc-col cs-dashboard-workspace-footer-right">
                                                    {item.type !== 'calendar' && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.c} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonRemove(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faTrashCan} />
                                                        </MbButton>
                                                    }
                                                    {!(item.type === 'calendar' || item.type === 'action' || item.type === 'patient' || (item.type === 'text' && item.subtitle === 'note')) && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.k} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonSave(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faFloppyDisk} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'data' && tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.j} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonDataDownload(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faCloudArrowDown} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'app' && tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.t} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonRunSim(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faCirclePlay} />
                                                        </MbButton>
                                                    }
                                                    {!(item.type === 'file' || item.type === 'data' || item.type === 'action' || item.type === 'patient' || item.type === 'app' || (item.type === 'text' && item.subtitle === 'note')) && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.l} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonOpen(item)} >
                                                            {ItemIconOpen(item)}
                                                        </MbButton>
                                                    }
                                                    {item.type === 'file' && item.subtitle.toLowerCase().includes('image') && tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.l} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonImage(item)} >
                                                            {ItemIconOpen(item)}
                                                        </MbButton>
                                                    }
                                                    {item.type === 'file' && !item.subtitle.toLowerCase().includes('image') && tab !== 'select' && !(item.type === 'text' && item.subtitle === 'note') &&
                                                        <MbButton disabled={Boolean(!Empty(toast))} title={locale.dashboardWorkspace.j} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color" onClick={() => ButtonFileDownload(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faCloudArrowDown} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'text' && item.subtitle === 'note' && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast)) || item.color === 'yellow'} title={locale.dashboardWorkspace.q} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color-yellow" onClick={() => ButtonNoteYellow(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faSquareFull} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'text' && item.subtitle === 'note' && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast)) || item.color === 'green'} title={locale.dashboardWorkspace.r} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color-green" onClick={() => ButtonNoteGreen(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faSquareFull} />
                                                        </MbButton>
                                                    }
                                                    {item.type === 'text' && item.subtitle === 'note' && tab !== 'select' &&
                                                        <MbButton disabled={Boolean(!Empty(toast)) || item.color === 'blue'} title={locale.dashboardWorkspace.ar} theme="ios" themeVariant="light" color="primary" flat={true} className="mbsc-bold cs-dashboard-workspace-color-blue" onClick={() => ButtonNoteBlue(item)} >
                                                            <FontAwesomeIcon className="cs-dashboard-workspace-icon" icon={faSquareFull} />
                                                        </MbButton>
                                                    }
                                                </div>
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </div>
                            );
                        })}
                    </div>
                </div>
            }
            {!loading && (tab === 'new' || ((tab === 'workspace' || tab === 'select') && (!workspace || workspace.length === 0))) &&
                <div className="mbsc-grid cs-dashboard-workspace-grid" contentEditable suppressContentEditableWarning={true} onPaste={InputPaste} onDragOver={(e) => e.preventDefault()} onDrop={InputDrop}>
                    <div className="mbsc-row cs-dashboard-workspace-main mbsc-justify-content-center">
                        <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-4 mbsc-col-lg-4 mbsc-col-xl-4 cs-dashboard-workspace-col"} >
                            <Card theme="ios" themeVariant="light" contentEditable="false" >
                                <CardHeader onMouseEnter={() => setIconHover('screen')} onMouseLeave={() => setIconHover(null)} theme="ios" themeVariant="light" className="mbsc-align-center cs-dashboard-workspace-title-empty-cursor" onClick={() => ButtonCreate('screen')}>
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon-new" icon={faCameraViewfinder} beatFade={iconHover === 'screen'} />
                                    <CardTitle theme="ios" themeVariant="light" className="cs-dashboard-workspace-title-empty-item" >
                                        {locale.dashboardWorkspace.ai}
                                    </CardTitle>
                                </CardHeader>
                            </Card>
                        </div>
                        <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-4 mbsc-col-lg-4 mbsc-col-xl-4 cs-dashboard-workspace-col"}>
                            <Card theme="ios" themeVariant="light" contentEditable="false" >
                                <CardHeader onMouseEnter={() => setIconHover('upload')} onMouseLeave={() => setIconHover(null)} theme="ios" themeVariant="light" className="mbsc-align-center cs-dashboard-workspace-title-empty-cursor" onClick={() => ButtonCreate('upload')}>
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon-new" icon={faUpload} beatFade={iconHover === 'upload'} />
                                    <CardTitle theme="ios" themeVariant="light" className="cs-dashboard-workspace-title-empty-item" >
                                        {locale.dashboardWorkspace.aj}
                                    </CardTitle>
                                </CardHeader>
                            </Card>
                        </div>
                        <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-4 mbsc-col-lg-4 mbsc-col-xl-4 cs-dashboard-workspace-col"}>
                            <Card theme="ios" themeVariant="light" contentEditable="false" >
                                <CardHeader onMouseEnter={() => setIconHover('text')} onMouseLeave={() => setIconHover(null)} theme="ios" themeVariant="light" className="mbsc-align-center cs-dashboard-workspace-title-empty-cursor" onClick={() => ButtonCreate('text')}>
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon-new" icon={faFontCase} beatFade={iconHover === 'text'} />
                                    <CardTitle theme="ios" themeVariant="light" className="cs-dashboard-workspace-title-empty-item" >
                                        {locale.dashboardWorkspace.ak}
                                    </CardTitle>
                                </CardHeader>
                            </Card>
                        </div>
                        <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-4 mbsc-col-lg-4 mbsc-col-xl-4 cs-dashboard-workspace-col"}>
                            <Card theme="ios" themeVariant="light" contentEditable="false" >
                                <CardHeader onMouseEnter={() => setIconHover('document')} onMouseLeave={() => setIconHover(null)} theme="ios" themeVariant="light" className="mbsc-align-center cs-dashboard-workspace-title-empty-cursor" onClick={() => ButtonCreate('document')}>
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon-new" icon={faFileLines} beatFade={iconHover === 'document'} />
                                    <CardTitle theme="ios" themeVariant="light" className="cs-dashboard-workspace-title-empty-item" >
                                        {locale.dashboardWorkspace.al}
                                    </CardTitle>
                                </CardHeader>
                            </Card>
                        </div>
                        <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-4 mbsc-col-lg-4 mbsc-col-xl-4 cs-dashboard-workspace-col"}>
                            <Card theme="ios" themeVariant="light" contentEditable="false" >
                                <CardHeader onMouseEnter={() => setIconHover('code')} onMouseLeave={() => setIconHover(null)} theme="ios" themeVariant="light" className="mbsc-align-center cs-dashboard-workspace-title-empty-cursor" onClick={() => ButtonCreate('code')}>
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon-new" icon={faCode} beatFade={iconHover === 'code'} />
                                    <CardTitle theme="ios" themeVariant="light" className="cs-dashboard-workspace-title-empty-item" >
                                        {locale.dashboardWorkspace.am}
                                    </CardTitle>
                                </CardHeader>
                            </Card>
                        </div>
                        <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-4 mbsc-col-lg-4 mbsc-col-xl-4 cs-dashboard-workspace-col"}>
                            <Card theme="ios" themeVariant="light" contentEditable="false" >
                                <CardHeader onMouseEnter={() => setIconHover('note')} onMouseLeave={() => setIconHover(null)} theme="ios" themeVariant="light" className="mbsc-align-center cs-dashboard-workspace-title-empty-cursor" onClick={() => ButtonCreate('note')}>
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon-new" icon={faNoteSticky} beatFade={iconHover === 'note'} />
                                    <CardTitle theme="ios" themeVariant="light" className="cs-dashboard-workspace-title-empty-item" >
                                        {locale.dashboardWorkspace.as}
                                    </CardTitle>
                                </CardHeader>
                            </Card>
                        </div>
                        <div className={width < 476 ? "mbsc-col-12 cs-dashboard-workspace-col" : "mbsc-col-6 mbsc-col-sm-6 mbsc-col-md-4 mbsc-col-lg-4 mbsc-col-xl-4 cs-dashboard-workspace-col"}>
                            <Card theme="ios" themeVariant="light" contentEditable="false" >
                                <CardHeader onMouseEnter={() => setIconHover('image')} onMouseLeave={() => setIconHover(null)} theme="ios" themeVariant="light" className="mbsc-align-center cs-dashboard-workspace-title-empty-cursor" onClick={() => ButtonCreate('image')}>
                                    <FontAwesomeIcon className="cs-dashboard-workspace-icon-new" icon={faFileImage} beatFade={iconHover === 'image'} />
                                    <CardTitle theme="ios" themeVariant="light" className="cs-dashboard-workspace-title-empty-item" >
                                        {locale.dashboardWorkspace.ao}
                                    </CardTitle>
                                </CardHeader>
                            </Card>
                        </div>
                    </div>
                </div>
            }
            {!loading && (tab === 'stack' || tab === 'items') &&
                <div className="cs-dashboard-workspace-scroll" >
                    <Listview
                        theme="ios"
                        themeVariant="light"
                        select="single"
                        itemType={ListItem}
                        data={ListData()}
                        onInit={(event, inst) => setListInstance(inst)}
                        actionsWidth={100}
                        actions={ListActions()}
                    />
                </div>
            }
            <div style={{display: 'none'}}>
                <input type="file" ref={hiddenFileInput} onChange={InputUpload} />
            </div>
        </Popup>
    );
}

export default DashboardWorkspace;
